import { useEffect } from "react";

import AppRoutes from "./app.routes";
import AuthRoutes from "./auth.routes";
import { useUserStore } from "@/store";

const RoutesProvider = () => {
  const { isAuthenticated, restoreSession } = useUserStore();

  useEffect(() => {
    restoreSession();
  }, [restoreSession]);

  console.log("is auth?", isAuthenticated)

  return <div>{isAuthenticated ? <AppRoutes /> : <AuthRoutes />}</div>;
};

export default RoutesProvider;
